module.exports = __webpack_public_path__ + "img/N016_unfold.782d90da.png";